<template>
    <div class>
        <!--=== Header Start ===-->
        <header v-show="false" class="header-navbar sticky-top">
            <div class="container-fluid p-0">
                <div class="row">
                <div class="col-md-12 px-0 py-0">
                    <div class="d-flex align-items-center justify-content-between">
                    <div class="left-logo edu-banner">
                        <a href>
                        <img id="imgBanner" v-bind:src="BannerURL" />
                        </a>
                    </div>
                    </div>
                    <div class="sstop-btn-hld">
                    <ul>
                        <li><a href="#">Get Help</a></li>
                        <li>
                        <router-link to="/events">Event Hub</router-link>
                        </li>
                        <li v-if="ShowCreateEventButton || true">
                        <button
                            class="btn btn-primary"
                            @click="DisplayCreateEventPopup"
                        >
                            Create Event
                        </button>
                        </li>
                        <li class="nav-item dropdown">
                        <a
                            class="nav-link dropdown-toggle"
                            href="#"
                            id="navbarDropdownMenuLink"
                            role="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            <img
                            src="../assets/Images/attendee.png"
                            width="40"
                            height="40"
                            class="rounded-circle"
                            />
                        </a>
                        <div
                            class="dropdown-menu"
                            aria-labelledby="navbarDropdownMenuLink"
                            style="right: 0 !important"
                        >
                            <!-- <a class="dropdown-item" href="#">Dashboard</a> -->
                            <a class="dropdown-item" href="#">Edit Profile</a>
                            <a
                            class="dropdown-item"
                            href="javascript:void(0)"
                            @click="Logout"
                            >Log Out</a
                            >
                        </div>
                        </li>
                    </ul>
                    </div>
                </div>
                </div>
            </div>
        </header>
        <div class="container-fluid">
            <div class="ss-event-hub-head">
                <h1 class="mt-5">Event Hub</h1>
                <p>Add our upcoming live journalism events to your calendar and receive the latest updates</p>
            </div>
            <div class="add-calender-event mt-6">
                <v-btn large depressed tile color="#f7f7f7"><v-icon class="mr-3" color="#ccc" size="25px">mdi-calendar-plus</v-icon> Add To Calender</v-btn>
            </div>
            
            <div class="ss-eventhub-filter">
                <div class="d-flex justify-content-between align-items-center" style="width: 100%;">
                    <div class="d-flex justify-content-start align-items-center" style="flex: 44% 0 0; width: 44%;">
                            <v-select :items="items" label="Themes" color="#ccc" outlined class="mr-3"></v-select>
                            <v-select :items="items2" label="Series" color="#ccc" outlined></v-select>
                    </div>
                    <div>
                        <input type="date" name="" value="" id="" placeholder="Calendar"/>
                    </div>
                </div>
                <div class="ss-eventhub-filter-tags mt-5">
                    <p><span>Health</span> <span><v-icon color="#333" size="18px">mdi-close</v-icon></span></p>
                    <p><span>WS Tech Live</span> <span > <v-icon color="#333" size="18px">mdi-close</v-icon></span></p>
                    <p class="clear-filter"><span class="redone">Clear Filters</span> <span > <v-icon color="#333" size="18px">mdi-close</v-icon></span></p>
                </div>
            </div>
            <div class="ss-eventhub-eventlist mt-12">
                <div class="ss-eventhub-single-event my-4">
                    <div class="ss-eventhub-event-image">
                        <img src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2F960X192_white.jpg?alt=media"/>
                    </div>
                    <div class="ss-eventhub-event-details">
                        <div class="d-flex justify-content-between align-items-center">
                            <p class="ss-eventhub-eventdate">DEC 16, 2021 - DEC 17, 2021</p>
                            <div class="ss-eventhub-event-tag">
                                <span>Leadership</span>
                                <span><v-icon color="#ccc" size="35px">mdi-calendar-plus</v-icon></span>
                            </div>
                        </div>
                        <h2>Reg V2 Test 3</h2>
                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took.</p>
                        <a href="">
                            LEARN MORE
                            <span>
                                <svg
                                    version="1.1"
                                    id="Capa_1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    x="0px"
                                    y="0px"
                                    fill="#333"
                                    width="24px"
                                    height="24px"
                                    viewBox="0 0 31.494 31.494"
                                    xml:space="preserve"
                                >
                                    <path
                                    d="M10.273,5.009c0.444-0.444,1.143-0.444,1.587,0c0.429,0.429,0.429,1.143,0,1.571l-8.047,8.047h26.554 c0.619,0,1.127,0.492,1.127,1.111c0,0.619-0.508,1.127-1.127,1.127H3.813l8.047,8.032c0.429,0.444,0.429,1.159,0,1.587 c-0.444,0.444-1.143,0.444-1.587,0l-9.952-9.952c-0.429-0.429-0.429-1.143,0-1.571L10.273,5.009z"
                                    style="fill: #bba364"
                                    ></path>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                </svg>
                            </span>
                        </a>
                    </div>
                </div>

                <div class="ss-eventhub-single-event my-4">
                    <div class="ss-eventhub-event-image">
                        <img src="https://resources.e2m.live/uate2monair.appspot.com/OA_UAT_C1591205467009E1622634512582%2FBranding%2F960x192_1622634651092.png?alt=media&token=e29c6c9d-72d2-4f7a-9c13-74e6c936a47d"/>
                    </div>
                    <div class="ss-eventhub-event-details">
                        <div class="d-flex justify-content-between align-items-center">
                            <p class="ss-eventhub-eventdate">DEC 16, 2021 - DEC 17, 2021</p>
                            <div class="ss-eventhub-event-tag">
                                <span>Leadership</span>
                                <span><v-icon color="#ccc" size="35px">mdi-calendar-plus</v-icon></span>
                            </div>
                        </div>
                        <h2>Economic Business Summit</h2>
                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took.</p>
                        <a href="">
                            LEARN MORE
                            <span>
                                <svg
                                    version="1.1"
                                    id="Capa_1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    x="0px"
                                    y="0px"
                                    fill="#333"
                                    width="24px"
                                    height="24px"
                                    viewBox="0 0 31.494 31.494"
                                    xml:space="preserve"
                                >
                                    <path
                                    d="M10.273,5.009c0.444-0.444,1.143-0.444,1.587,0c0.429,0.429,0.429,1.143,0,1.571l-8.047,8.047h26.554 c0.619,0,1.127,0.492,1.127,1.111c0,0.619-0.508,1.127-1.127,1.127H3.813l8.047,8.032c0.429,0.444,0.429,1.159,0,1.587 c-0.444,0.444-1.143,0.444-1.587,0l-9.952-9.952c-0.429-0.429-0.429-1.143,0-1.571L10.273,5.009z"
                                    style="fill: #bba364"
                                    ></path>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                </svg>
                            </span>
                        </a>
                    </div>
                </div>

                <div class="ss-eventhub-single-event my-4">
                    <div class="ss-eventhub-event-image">
                        <img src="https://storage.googleapis.com/uate2monair.appspot.com/OA_UAT_C1591904892446E1598284508652/Branding/1638950113129-960x192.jpg"/>
                    </div>
                    <div class="ss-eventhub-event-details">
                        <div class="d-flex justify-content-between align-items-center">
                            <p class="ss-eventhub-eventdate">DEC 20, 2021 - DEC 30, 2021</p>
                            <div class="ss-eventhub-event-tag">
                                <span>Leadership</span>
                                <span><v-icon color="#ccc" size="35px">mdi-calendar-plus</v-icon></span>
                            </div>
                        </div>
                        <h2>Millennium 2020</h2>
                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took.</p>
                        <a href="">
                            LEARN MORE
                            <span>
                                <svg
                                    version="1.1"
                                    id="Capa_1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    x="0px"
                                    y="0px"
                                    fill="#333"
                                    width="24px"
                                    height="24px"
                                    viewBox="0 0 31.494 31.494"
                                    xml:space="preserve"
                                >
                                    <path
                                    d="M10.273,5.009c0.444-0.444,1.143-0.444,1.587,0c0.429,0.429,0.429,1.143,0,1.571l-8.047,8.047h26.554 c0.619,0,1.127,0.492,1.127,1.111c0,0.619-0.508,1.127-1.127,1.127H3.813l8.047,8.032c0.429,0.444,0.429,1.159,0,1.587 c-0.444,0.444-1.143,0.444-1.587,0l-9.952-9.952c-0.429-0.429-0.429-1.143,0-1.571L10.273,5.009z"
                                    style="fill: #bba364"
                                    ></path>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                </svg>
                            </span>
                        </a>
                    </div>
                </div>

                <div class="ss-eventhub-single-event my-4">
                    <div class="ss-eventhub-event-image">
                        <img src="https://resources.e2m.live/uate2monair.appspot.com/OA_UAT_C1591205467009E1591206650065%2FBranding%2F960x192.jpg?alt=media&token=79a27842-e4d8-469b-8f88-30328a0442d0"/>
                    </div>
                    <div class="ss-eventhub-event-details">
                        <div class="d-flex justify-content-between align-items-center">
                            <p class="ss-eventhub-eventdate">JAN 05, 2022 - JAN 10, 2022</p>
                            <div class="ss-eventhub-event-tag">
                                <span>Leadership</span>
                                <span><v-icon color="#ccc" size="35px">mdi-calendar-plus</v-icon></span>
                            </div>
                        </div>
                        <h2>Shobiz Experience 2020</h2>
                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took.</p>
                        <a href="">
                            LEARN MORE
                            <span>
                                <svg
                                    version="1.1"
                                    id="Capa_1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    x="0px"
                                    y="0px"
                                    fill="#333"
                                    width="24px"
                                    height="24px"
                                    viewBox="0 0 31.494 31.494"
                                    xml:space="preserve"
                                >
                                    <path
                                    d="M10.273,5.009c0.444-0.444,1.143-0.444,1.587,0c0.429,0.429,0.429,1.143,0,1.571l-8.047,8.047h26.554 c0.619,0,1.127,0.492,1.127,1.111c0,0.619-0.508,1.127-1.127,1.127H3.813l8.047,8.032c0.429,0.444,0.429,1.159,0,1.587 c-0.444,0.444-1.143,0.444-1.587,0l-9.952-9.952c-0.429-0.429-0.429-1.143,0-1.571L10.273,5.009z"
                                    style="fill: #bba364"
                                    ></path>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                </svg>
                            </span>
                        </a>
                    </div>
                </div>

                <div class="ss-eventhub-single-event my-4">
                    <div class="ss-eventhub-event-image">
                        <img src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FBranding%2FMail%20Banner.jpg?alt=media"/>
                    </div>
                    <div class="ss-eventhub-event-details">
                        <div class="d-flex justify-content-between align-items-center">
                            <p class="ss-eventhub-eventdate">Jan 08, 2022 - JAN 12, 2022</p>
                            <div class="ss-eventhub-event-tag">
                                <span>Leadership</span>
                                <span><v-icon color="#ccc" size="35px">mdi-calendar-plus</v-icon></span>
                            </div>
                        </div>
                        <h2>BNI Cochin</h2>
                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took.</p>
                        <a href="">
                            LEARN MORE
                            <span>
                                <svg
                                    version="1.1"
                                    id="Capa_1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    x="0px"
                                    y="0px"
                                    fill="#333"
                                    width="24px"
                                    height="24px"
                                    viewBox="0 0 31.494 31.494"
                                    xml:space="preserve"
                                >
                                    <path
                                    d="M10.273,5.009c0.444-0.444,1.143-0.444,1.587,0c0.429,0.429,0.429,1.143,0,1.571l-8.047,8.047h26.554 c0.619,0,1.127,0.492,1.127,1.111c0,0.619-0.508,1.127-1.127,1.127H3.813l8.047,8.032c0.429,0.444,0.429,1.159,0,1.587 c-0.444,0.444-1.143,0.444-1.587,0l-9.952-9.952c-0.429-0.429-0.429-1.143,0-1.571L10.273,5.009z"
                                    style="fill: #bba364"
                                    ></path>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                </svg>
                            </span>
                        </a>
                    </div>
                </div>

                <div class="ss-eventhub-single-event my-4">
                    <div class="ss-eventhub-event-image">
                        <img src="https://resources.e2m.live/uate2monair.appspot.com/OA_UAT_C1598265893334E1598266206755%2FBranding%2F960x192.png?alt=media&token=b88d8a5c-250d-4cd8-9be1-d3eda67d680f"/>
                    </div>
                    <div class="ss-eventhub-event-details">
                        <div class="d-flex justify-content-between align-items-center">
                            <p class="ss-eventhub-eventdate">FEB 10, 2022 - FEB 13, 2022</p>
                            <div class="ss-eventhub-event-tag">
                                <span>Leadership</span>
                                <span><v-icon color="#ccc" size="35px">mdi-calendar-plus</v-icon></span>
                            </div>
                        </div>
                        <h2>UJIA Centenary Celebration</h2>
                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took.</p>
                        <a href="">
                            LEARN MORE
                            <span>
                                <svg
                                    version="1.1"
                                    id="Capa_1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    x="0px"
                                    y="0px"
                                    fill="#333"
                                    width="24px"
                                    height="24px"
                                    viewBox="0 0 31.494 31.494"
                                    xml:space="preserve"
                                >
                                    <path
                                    d="M10.273,5.009c0.444-0.444,1.143-0.444,1.587,0c0.429,0.429,0.429,1.143,0,1.571l-8.047,8.047h26.554 c0.619,0,1.127,0.492,1.127,1.111c0,0.619-0.508,1.127-1.127,1.127H3.813l8.047,8.032c0.429,0.444,0.429,1.159,0,1.587 c-0.444,0.444-1.143,0.444-1.587,0l-9.952-9.952c-0.429-0.429-0.429-1.143,0-1.571L10.273,5.009z"
                                    style="fill: #bba364"
                                    ></path>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                    <g></g>
                                </svg>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// import HelloWorld from "@/components/HelloWorld.vue";
// import Router from "vue-router";
// import firebase from "firebase";
import APIs from "@/components/APIInit";
import db from "../components/firebaseInit";
import firebase from "firebase";
import store from "../store";
import router from "../router";
import jQuery from "jquery";
let $ = jQuery;
import Vue from "vue";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import axios from "axios";
import { bus } from "@/main";
import jwt_decode from "jwt-decode";

Vue.use(VueMoment, {
  moment,
});

var self;
var eventCloneProgress;
export default {
  data() {
    return {
      tempAdminEvent: null,
      uid: "",
      APIs: APIs,
      noEventLink: "https://e2m.live/",
      EventsData: [],
      clientID: "", //this.$store.getters.getClient[0].id,
      BannerURL: "",
      noEventMessage: false,
      isMobileSearch: false,
      mobileBanner: "",
      desktopBanner: "",
      ShowCreateEventButton: false,
      searchText: "",
      filterDateFrom: "",
      filterDateTo: "",
      filterStatus: "",
      tab: null,
      switch1: true,
      radioGroup: 1,
      items: ["Heath", "Technology", "Food", "Leadership", "Cyber Security", "Business Mangement"],
      items2: ["The Future of Everything", "Women In Forum", "WS Tech Live", "CEO Council Sumit"],
      //currentTab: "Overview",
    };
  },
  computed: {
    hasSession() {
      if (self.uid) {
        return true;
      } else {
        return false;
      }
    },
    SearchEventsData() {
      var result = [];
      var searchText = (self.searchText ? self.searchText : "")
        .trim()
        .toLowerCase();
      if (!searchText) {
        result = self.EventsData.filter(function () {
          return true;
        });
      } else {
        result = self.EventsData.filter(function (item) {
          if (item.Name.toLowerCase().includes(searchText.toLowerCase())) {
            return true;
          }
        });
      }
      if (self.filterDateFrom) {
        let filterDateFrom = new Date(self.filterDateFrom);
        let startSeconds = parseInt(filterDateFrom.getTime() / 1000);
        result = result.filter(function (item) {
          if (startSeconds < item.EventEndDateS) {
            return true;
          }
        });
      }
      if (self.filterDateTo) {
        let filterDateTo = new Date(self.filterDateTo);
        filterDateTo.setDate(filterDateTo.getDate() + 1);
        let endSeconds = parseInt(filterDateTo.getTime() / 1000);
        result = result.filter(function (item) {
          if (endSeconds > item.EventEndDateS) {
            return true;
          }
        });
      }
      if (self.filterStatus) {
        var filterStatus = self.filterStatus == "true" ? true : false;
        result = result.filter(function (item) {
          return item.IsPublished == filterStatus;
        });
      }
      return result;
    },
  },
  watch: {
    //searchText(val) {
    //  alert(val);
    //},
  },
  beforeCreate() {
    // setTimeout(() => {
    //   setTimeout(() => {
    //     setTimeout(() => {
    //       $("#app").addClass("full-screen");
    //     }, 100);
    //     $("#app").addClass("full-screen");
    //   }, 100);
    //   $("#app").addClass("full-screen");
    // }, 100);
    // $("#app").addClass("full-screen");
  },
  created() {
    self = this;
    self.uid = self.getSessionUserId();
    self.initScreen();
    $(window).resize(function () {
      self.initScreen();
    });

    let urlParams = String(window.location.href).split("#");
    if (
      urlParams.length > 1 &&
      urlParams[1].toLowerCase() == "managemyevents"
    ) {
      self.tab = "ManageMyEvents";
    }
  },
  mounted() {
    self.tempAdminEvent = self.$store.getters.getTempAdminEvent;
    if (!self.tempAdminEvent) {
      self.tempAdminEvent = new Object();
    }
    self.tempAdminEvent.Status = "In Progress";
    console.log("tempAdminEvent========", self.tempAdminEvent);
    if (self.tempAdminEvent && self.tempAdminEvent.DocPath != null) {
      if (eventCloneProgress) {
        eventCloneProgress();
        eventCloneProgress = undefined;
      }
      eventCloneProgress = db
        .doc(self.tempAdminEvent.DocPath)
        .onSnapshot((doc) => {
          //alert("in");
          debugger;
          if (doc.exists) {
            let data = doc.data();
            self.tempAdminEvent.StatusId = parseInt(data.status);
            if (isNaN(self.tempAdminEvent.StatusId)) {
              self.tempAdminEvent.StatusId = 0;
            }
            self.tempAdminEvent.Status = data.msg;
            //console.log("data========", data);
            if (self.tempAdminEvent.StatusId == 200) {
              if (eventCloneProgress) {
                eventCloneProgress();
                eventCloneProgress = undefined;
              }
              self.tempAdminEvent = null;
              self.refreshIdToken();
            } else if (self.tempAdminEvent.StatusId < 0) {
              self.showSnackbar(
                "Something went wrong. Click Retry to create the event",
                "error",
                "top"
              );
            }
          }
        });
    }

    self.noEventLink = self.$t("client.registerRoute");
    self.clientID = self.$route.query.c;
    //this.clientID = self.$route.params.c;
    /* $("#alleventSec").css("background-size", "cover");
    $("#alleventSec").css("background-color", "none");
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    $("#alleventSec").css(
      "background-image",
      "url(" + obj.branding[0].bg2 + ")"
    );
    $("#alleventSec").css("background-size", "100%");
    //alert(obj.Branding[0].banner)
    $("#imgBanner").attr("src", obj.branding[0].banner);

    $(".clsDynamicColor").css("color", obj.branding[0].bodyTextColor);*/
    //debugger;
    // $("#topmenu").hide();
    // $("#leftmenu").hide();
    // var obj = JSON.parse(window.localStorage.getItem("my-app"));
    // this.BannerURL = obj.branding[0].banner;
    /*+++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
    //  self.tid =
    //   this.$route.params.tid == undefined ? "" : this.$route.params.tid;

    //-------------------------GEt client id by host---------------------------------------
    //self.clientID = this.$route.params.c;
    const HOSTURL = process.env.VUE_APP_LOCALHOST_URL_EDU;
    if (location.host.toLowerCase().indexOf("localhost") >= 0) {
      //this.result = "uatonair.e2m.live";
      //self.hostName = "onair.e2m.live";
      self.hostName = HOSTURL ? HOSTURL : "uatonair.e2m.live";
      // self.hostName = "uatbni.e2m.live";
      // this.result = "tci.e2m.live";
      //this.result = "uatcapitalgroup.e2m.live";
    } else {
      self.hostName = HOSTURL ? HOSTURL : location.host;
      //self.hostName = location.host;
    }
    var path;
    //console.log(self.hostName);
    if (this.hostName.toLowerCase().indexOf("uat") > -1) {
      path = "https://resources.e2m.live/uate2monair.appspot.com/";
    } else {
      path = APIs.googleSoragePath;
    }
    axios
      .get(
        path + "OA_UAT%2FClients%2FHosts%2F" + this.hostName + ".json?alt=media"
      )
      .then((res) => {
        if (res && res.data) {
          bus.$emit("EnableHelpChat", "Event", res.data.ClientId);
        }
        self.clientID = res.data.ClientId;
        //self.clientName = res.data.ClientName;
        document.title = res.data.ClientName;
        if (
          res.data.EventListAssets &&
          res.data.EventListAssets.banner2048x88
        ) {
          self.desktopBanner = res.data.EventListAssets.banner2048x88;
        }
        if (
          res.data.EventListAssets &&
          res.data.EventListAssets.banner750x103
        ) {
          self.mobileBanner = res.data.EventListAssets.banner750x103;
        }
        self.initScreen();
        self.EventsData = [];
        self.displayEvents();
      });
  },
  methods: {
    enterInsideEvent(event) {
      self.ChangeCurrentEvent(event.clientID, event.id);
    },
    ChangeTab(tab) {
      self.tab = tab;
      debugger;
      location.hash = tab;
      //router.push("")
    },
    Logout() {
      bus.$emit("clearState");
    },
    initScreen() {
      if (window.innerWidth > 768) {
        self.isMobileSearch = false;
        self.BannerURL = self.desktopBanner;
      } else {
        self.isMobileSearch = true;
        self.BannerURL = self.mobileBanner;
      }
    },
    stopShimmer() {
      $(".shimmer-effect").css("display", "none");
    },
    mob_elist_search() {
      $("#mob_ev_search").css("display", "block");
      $(".mob_search_button").css("opacity", "0 ");
    },
    DisplayCreateEventPopup() {
      //$("#SignUpModal").modal("show");
    },
    refreshIdToken() {
      firebase.auth().onAuthStateChanged(function (user) {
        if (user) {
          firebase
            .auth()
            .currentUser.getIdToken(true)
            .then((idToken) => {
              var decoded = jwt_decode(idToken);
              document.cookie = "token=";
              document.cookie = "token=" + idToken + ";";
              store.commit("setCurrentLoggedInTime", decoded.exp);
              store.commit("addToken", idToken);
              self.displayEvents();
            })
            .catch((err) => {
              console.log("token set error==", err);
            });
        }
      });
    },
    displayEvents() {
      let headers = {
        Authorization: "Bearer " + self.getSessionToken(),
        "content-type": "application/json",
      };
      axios
        .get(self.APIs.UserEvent, {
          headers: headers,
        })
        .then((response) => {
          self.EventsData = [];
          var clients = response.data.result;
          var AdminRoles = [];
          if (response.data.profile && response.data.profile.AdminRoles) {
            store.commit("setAdminRoles", response.data.profile.AdminRoles);
            AdminRoles = response.data.profile.AdminRoles;
            // ClientId: "C1591205467009";
            // EventId: "E1637219036051";
            // RoleID: 3;
            // RoleName: "EventAdmin";
          }
          //debugger;
          for (var n = 0; n < clients.length; n++) {
            var client = clients[n];
            var events = client.events;
            for (var i = 0; i < events.length; i++) {
              var event = events[i];
              var adminEvents = AdminRoles.filter(function (item) {
                return (
                  item.ClientId == event.ClientId &&
                  item.EventId == event.EventId
                );
              });
              console.log("adminEvents=======", adminEvents);

              if (adminEvents.length == 0) {
                continue;
              }
              let startTime = event.EventStartDateTime.substring(11, 16);
              let endTime = event.EventEndDateTime.substring(11, 16);
              self.EventsData.push({
                id: event.EventId,
                Name: event.EventFullName,
                EventLogo: self.getCDNUrl(event.EventLogo),
                EventStartDate: event.EventStartDate,
                EventEndDate: event.EventEndDate,
                EventCollectionName: event.EventCollectionName,
                EventTypeId: event.EventTypeId,
                EventTimezone: moment.tz.guess(), // data.TimeZone,
                EventStartDateS: event.EventStartDateTimestamp,
                EventEndDateS: event.EventEndtDateTimestamp,
                EventNewStartTime: self.SetTimeByZone(
                  moment(event.EventStartDate, ["DD-MM-YYYY"]).format(
                    "MMM DD, YYYY"
                  ) +
                    " " +
                    startTime,
                  moment.tz.guess()
                ),
                EventStartDateString:
                  moment(event.EventStartDate, ["DD-MM-YYYY"]).format(
                    "MMM DD, YYYY"
                  ) +
                  " " +
                  startTime, //self.formatDate(data.EventStartDate),
                EventEndDateString:
                  moment(event.EventEndDate, ["DD-MM-YYYY"]).format(
                    "MMM DD, YYYY"
                  ) +
                  " " +
                  endTime,
                EventNewEndTime: self.SetTimeByZone(
                  moment(event.EventEndDate, ["DD-MM-YYYY"]).format(
                    "MMM DD, YYYY"
                  ) +
                    " " +
                    endTime,
                  moment.tz.guess()
                ),
                IsPublished: event.IsPublished,
                StatusClass: event.IsPublished ? "" : "event-unpublished",
                status: event.status,
                clientID: event.ClientId,
                eventDefaultSessionPage: event.DefaultSessionPath
                  ? event.DefaultSessionPath
                  : "",
                DefaultLanguage:
                  event.DefaultLanguage === undefined
                    ? "English"
                    : event.DefaultLanguage,
              });
            }
          }
          self.refreshToken(response.data.customToken);
        })
        .catch((error) => {
          console.log(error);
        });
      // if (self.tabclickflag != true) {
      //   if (self.liveflag <= 0) {
      //     self.fliterflag = 2;
      //     $("#aEndedtab").removeClass("active");
      //     $("#aLivetab").removeClass("active");
      //     $("#aunderreviewtab").addClass("active");
      //     $("#aAlltab").removeClass("active");
      //     if (self.UnderReviewFlag <= 0 && self.liveflag <= 0) {
      //       self.fliterflag = 0;
      //       $("#aEndedtab").addClass("active");
      //       $("#aLivetab").removeClass("active");
      //       $("#aunderreviewtab").removeClass("active");
      //       $("#aAlltab").removeClass("active");

      //       if (
      //         self.Pastflag <= 0 &&
      //         self.UnderReviewFlag <= 0 &&
      //         self.liveflag <= 0
      //       ) {
      //         self.fliterflag = 3;
      //         $("#aEndedtab").removeClass("active");
      //         $("#aLivetab").removeClass("active");
      //         $("#aunderreviewtab").removeClass("active");
      //         $("#aAlltab").addClass("active");
      //       }
      //     }
      //   }
      // }

      // self.tabclickflag = false;
      // if (self.EventsData.length > 0) {
      //   self.eventCount = self.EventsData.length;
      //   if (self.fliterflag == 1) {
      //     debugger;
      //     self.EventsData = self.EventsData.filter(function (e) {
      //       return e.status == "live" || e.status == "upcoming";
      //     });
      //   } else if (self.fliterflag == 2) {
      //     self.EventsData = self.EventsData.filter(function (e) {
      //       return e.status == "underreview";
      //     });
      //   } else if (self.fliterflag == 0) {
      //     self.EventsData = self.EventsData.filter(function (e) {
      //       return e.status == "ended";
      //     });
      //   } else {
      //     debugger;
      //     self.EventsData = self.EventsData.filter(function (e) {
      //       return e.status.Contains(
      //         "live",
      //         "upcoming",
      //         "underreview",
      //         "ended"
      //       );
      //     });
      //   }
      // } else {
      //   self.eventCount = 0;
      // }
      //store.commit("addEventCount", self.eventCount);

      // if (self.sortOrder == "desc") {
      //   self.EventsData = self.EventsData.sort(function compare(a, b) {
      //     //parseInt(new Date(events[i].EventStartDateTime).getTime() / 1000)
      //     var dateA = parseInt(new Date(a.EventStartDateTime).getTime() / 1000);
      //     var dateB = parseInt(new Date(b.EventStartDateTime).getTime() / 1000);
      //     return dateB - dateA;
      //   });
      // } else {
      //   self.EventsData = self.EventsData.sort(function compare(a, b) {
      //     //parseInt(new Date(events[i].EventStartDateTime).getTime() / 1000)
      //     var dateA = parseInt(new Date(a.EventStartDateTime).getTime() / 1000);
      //     var dateB = parseInt(new Date(b.EventStartDateTime).getTime() / 1000);
      //     return dateA - dateB;
      //   });
      // }

      // if (self.eventCount == 1) {
      //   self.gotolobby = true;
      //   alert(self.$t("eventlist.routeMessageOnSingleEvent"));
      //   self.$router.push(eventDoc[1].DefaultLandingURL);
      //   self.goToEvent(eventDoc, eventDoc.DefaultSessionPath);
      // } else if (self.eventCount > 1) {
      //   self.gotolobby = false;
      // } else {
      //   //Not registered to any event
      //   //router.push({ name: "Login" });
      // }
    },
    refreshToken(token) {
      firebase
        .auth()
        .signInWithCustomToken(token)
        .then(function (res) {
          res.user
            .getIdToken(true)
            .then((idToken) => {
              var decoded = jwt_decode(idToken);
              document.cookie = "token=";
              document.cookie = "token=" + idToken + ";";
              self.$store.commit("addToken", idToken);
              self.$store.commit("setCurrentLoggedInTime", decoded.exp);
              document.cookie = "staysigned=";
              document.cookie = "userrole=";
              document.cookie = "userid=";
            })
            .catch((err) => {
              console.log("err=====", err);
            });
        })
        .catch(function (e) {
          console.log(e);
        });
    },
    SetTimeByZone: function (strDateTime, timeZone) {
      var date = moment.tz(strDateTime, timeZone).format("MMM DD, YYYY HH:mm");
      return date;
    },
    displayEventsReg() {
      //debugger;
      this.pageIndex++;
      var listRef = db
        .collection("OA_UAT/ClientList/Clients")
        .doc(self.clientID)
        .collection("Events");
      var cnt = 0;
      listRef
        //.where("IsPublished", "==", true)
        //.where("AllowRegistration", "==", true)
        .where("EventTypeId", "==", 2)
        //.get()
        .onSnapshot((querySnapshot) => {
          this.EventsData = [];
          debugger;
          if (querySnapshot.docs.length > 0) {
            querySnapshot.forEach((doc) => {
              cnt++;
              var data = doc.data();
              /* this.EventsData.push({
                id: doc.id,
                Name: data.EventFullName,
                EventLogo: data.EventLogo,
                EventStartDate: data.EventStartDate,
                EventEndDate: data.EventEndDate,
                EventCollectionName: data.EventCollectionName,
                EventTypeId: data.EventTypeId,
                EventTimezone: data.TimeZone,
                EventStartDateString: self.formatDate(data.EventStartDate),
                EventEndDateString: self.formatDate(data.EventEndDate)
              });*/
              var obj = new Object();
              obj.id = doc.id;
              obj.Name = data.EventFullName;
              obj.EventLogo = data.EventLogo;
              // obj.EventStartDate = data.EventStartDate;
              // obj.EventEndDate = data.EventEndDate;
              obj.EventCollectionName = data.EventCollectionName;
              obj.EventTypeId = data.EventTypeId;
              obj.EventTimezone = moment.tz.guess(); //data.TimeZone;
              //-------------------------------------------------------------------------------------------
              /* var mZone = moment.tz.guess();
              //obj.EventStartDateString = self.formatDate(data.EventStartDate);
              if (data.TimeZone != mZone) {
                var EventStartDate = self.formatDateTimeZoneWise(
                  data.EventStartDate
                );
                var momnt = moment.tz(EventStartDate, data.TimeZone);
                var strtDate = momnt.clone().tz(moment.tz.guess());
                obj.EventStartDateString = self.GetActualDateFormat(
                  strtDate.format()
                );
              } else {
                obj.EventStartDateString = self.formatDate(data.EventStartDate);
              }*/
              var dateFormat = require("dateformat");

              var dtstrt = new Date(data.EventStartDate.seconds * 1000);
              obj.EventStartDateString = dateFormat(dtstrt, "mmm dd, hh:MM TT");
              // obj.EventStartDateString = moment(dtstrt).format(
              //   " MMMM Do, h:mm a"
              // );
              //self.formatDate(data.EventStartDate);
              //------------------------------------------------------------------------------------------------
              /*if (data.TimeZone != mZone) {
                // obj.EventEndDateString = self.formatDate(data.EventEndDate);
                var EventEndDate = self.formatDateTimeZoneWise(
                  data.EventEndDate
                );
                var momnt2 = moment.tz(EventEndDate, data.TimeZone);
                var endDate = momnt2.clone().tz(moment.tz.guess());
                obj.EventEndDateString = self.GetActualDateFormat(
                  endDate.format()
                );
              } else {
                obj.EventEndDateString = self.formatDate(data.EventEndDate);
              }*/
              var dtend = new Date(data.EventEndDate.seconds * 1000);
              obj.EventEndDateString = dateFormat(dtend, "mmm dd, hh:MM TT"); // self.formatDate(data.EventEndDate);
              obj.EventStartDate = data.EventStartDate;
              obj.EventEndDate = data.EventEndDate;
              //------------------------------------------------------------------------------------------------
              self.EventsData.push(obj);
            });
            //debugger;
            self.noEventMessage = self.EventsData.length > 0 ? false : true;
            self.EventsData = self.EventsData.sort(function compare(a, b) {
              //debugger;
              //parseInt(new Date(events[i].EventStartDateTime).getTime() / 1000)
              var dateA = parseInt(
                new Date(a.EventStartDate.seconds * 1000).getTime() / 1000
              );
              var dateB = parseInt(
                new Date(b.EventStartDate.seconds * 1000).getTime() / 1000
              );
              return dateB - dateA;
            });
            if (cnt == 1) {
              //debugger;
              //router.push({
              //  path:
              //    "/event/" +
              //    this.EventsData[0].id +
              //    "/" +
              //    this.EventsData[0].Name
              //});
              router.push({
                path: "/event/" + this.EventsData[0].id,
              });
            }
          } else {
            self.noEventMessage = true;
          }
        });
      // .catch(error => {
      //   alert(error);
      //   // console.log("Error getting documents: ", error);
      // });
    },
    GetActualDateFormat: function (actualDt) {
      var dt = actualDt.split("T");
      var oDt = new Date(dt[0]).toDateString();

      var oTt = dt[1];
      var arrDate = oDt.split(" ");
      var accDate = arrDate[1] + " " + arrDate[2];

      var arrtime = oTt.split(":");
      var accTime = arrtime[0] + ":" + arrtime[1];

      var fullStartDate = accDate + " " + accTime;
      return fullStartDate;
    },
    formatDateTimeZoneWise: function (seconds) {
      var dateString = "";
      try {
        var dt = new Date(seconds.seconds * 1000);
        //debugger;

        var hrs = dt.getHours();
        hrs = hrs == 0 ? "00" : hrs;
        if (hrs != "00" && parseInt(hrs) < 10) {
          hrs = "0" + hrs;
        }

        var minutes = dt.getMinutes();
        minutes = minutes == 0 ? "00" : minutes;
        if (minutes != "00" && parseInt(minutes) < 10) {
          minutes = "0" + minutes;
        }

        var mnths = dt.getMonth();
        var accurateMon = mnths + 1;
        if (parseInt(accurateMon) < 10) {
          accurateMon = "0" + accurateMon;
        }

        dateString +=
          dt.getFullYear() +
          "-" +
          accurateMon +
          "-" +
          dt.getDate() +
          " " +
          hrs +
          ":" +
          minutes;

        //return dt.toLocaleDateString();
      } catch (ex) {
        console.log(ex);
      }
      return dateString;
    },
    goForLogin: function () {
      router.push({ name: "Login" });
    },
    selectEvent: function (eventId, evntName) {
      console.log("evntName:--- " + evntName);
      router.push({
        path: "/event/" + eventId,
      });
    },
    formatDate: function (seconds) {
      var dateString = "";
      //  alert(seconds);
      // if (seconds == 1594125120) {
      //   debugger;
      // }
      try {
        var dt = new Date(seconds.seconds * 1000);
        const monthNamesShort = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        var minutes = dt.getMinutes();
        minutes = minutes == 0 ? "00" : minutes;
        if (minutes != "00" && parseInt(minutes) < 10) {
          minutes = "0" + minutes;
        }
        dateString +=
          dt.getDate() +
          " " +
          monthNamesShort[dt.getMonth()] +
          " " +
          dt.getHours() +
          ":" +
          minutes;
        //return dt.toLocaleDateString();
      } catch (ex) {
        console.log(ex);
      }
      return dateString;
    },
    /* ,
    computed: {
      BannerURL() {
        // debugger;
        // var obj = JSON.parse(window.localStorage.getItem("my-app"));
        // return obj.branding[0].banner;
        //  db.collection("OA_UAT")
        //         .doc("ClientList")
        //         .collection("Clients")
        //         .where("CustomDomain", "==", this.result)
        //         .get()
        //         .then(querySnapshot => {
        //           querySnapshot.forEach(doc => {
        //           });
        //         });
      },
      pageBg() {
        var obj = JSON.parse(window.localStorage.getItem("my-app"));
        return obj.EventBranding[0].bg2;
      }
    }*/
  },
};
</script>
<style>
.no-reg-events {
  margin: 0 auto;
  text-align: center;
}
.no-reg-events h3 {
  font-weight: 700;
  font-size: 30px;
  color: #333;
  margin-bottom: 25px;
}
.no-reg-events a {
  display: inline-block;
  padding: 8px 30px;
  background: #00a982;
  color: #fff !important;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  border-radius: 5px;
  box-shadow: 0 5px 0 rgba(0, 0, 0, 0.5);
  margin-top: 15px;
}
.no-reg-events a:active {
  transform: translateY(5px);
  box-shadow: none;
}
.event-list-register-shimmer photo {
  display: block;
  width: 100%;
  height: 88px;
}
.shine {
  background: #f6f7f8;
  background-image: linear-gradient(
    to right,
    #f6f7f8 0%,
    #edeef1 20%,
    #f6f7f8 40%,
    #f6f7f8 100%
  );
  background-repeat: no-repeat;
  background-size: 800px 100%;
  display: inline-block;
  position: relative;

  -webkit-animation-duration: 1s;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-name: placeholderShimmer;
  -webkit-animation-timing-function: linear;
}
.top-right-login.hdr-btn {
  padding: 0 0 15px;
}
.top-right-login.hdr-btn a.login,
.top-right-login.hdr-btn a.event-List {
  font-size: 18px;
  padding-right: 0 !important;
  margin-left: 25px;
  cursor: pointer;
  background-position: left center;
}
.left-logo.edu-banner {
  width: 100% !important;
}
.event-box-list-wrapper .ev-box {
  border-radius: 5px;
  cursor: pointer;
}
section.event-box-list-wrapper {
  margin-top: 25px;
}
@media only screen and (max-width: 767px) {
  /* .left-logo.edu-banner {
  display: none;
} */
  .left-logo.edu-banner a {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .left-logo.edu-banner a img {
    width: 100%;
    height: 100%;
  }
  .reg-event-banner {
    padding: 20px 0 !important;
    margin-top: 24px;
  }
  .edu-rage .reg-event-banner h1 {
    margin-top: 0;
  }
}
</style>
